// extracted by mini-css-extract-plugin
export default {"container":"DashboardOIGSAMItem_container__XbqrN","item":"DashboardOIGSAMItem_item__UMsz7"};